module.exports = __webpack_public_path__ + "static/parade-2020-house29-766c3e4fb94a32da43cbee874f6b1738.jpg";